// @core/api/endpoints/team/grant_team_ownership.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GrantTeamOwnershipRequest,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Grant team ownership
 * Grants ownership privileges to a team member. The team can have multiple owners with equal administrative rights.
 */
export async function GrantTeamOwnership(
  team_id: string,
  data: GrantTeamOwnershipRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/ownership/grant`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
